"use client";

import { motion } from "motion/react";

import { MOTION } from "./motion-props";

import type { PropsWithChildren } from "react";

export function Animation({
  children,
  type = "splash-in",
}: PropsWithChildren<{
  type?: keyof typeof MOTION;
}>) {
  return <motion.div {...MOTION[type].props}>{children}</motion.div>;
}
